// ---------------------------------------------------------------------------
// แค็ตตาล็อกโมเดล
//  - kind "local": รันในเบราว์เซอร์จริงด้วย WebLLM (ใช้งานได้ตอนนี้) — webllmId = model_id ใน prebuiltAppConfig ของ @mlc-ai/web-llm@0.2.86
//  - kind "cloud": โมเดลจากผู้ให้บริการภายนอก แสดงในหน้าจอไว้ก่อน (status "soon") รอเชื่อม API
//  rate = ตัวคูณ token (ต้นทุน = token ที่ใช้ × rate) ; super_user ปรับ rate/สถานะ/การแสดงผลได้ที่ /admin/models (เก็บที่ settings/models)
//  downloadMB ประมาณจากขนาดไฟล์น้ำหนักบน HuggingFace ; vramMB = vram_required_MB
// ---------------------------------------------------------------------------
export const CHAT_MODELS = [
  { id: "qwen-0.5b", kind: "local", webllmId: "Qwen2.5-0.5B-Instruct-q4f16_1-MLC", name: "Qwen 2.5 Mini", provider: "Alibaba · ในเครื่อง", color: "#7c5cff", rate: 1, downloadMB: 278, vramMB: 945, tags: ["เร็ว", "ประหยัด"], desc: "เล็กและเร็วที่สุด เหมาะกับคำถามสั้นๆ ภาษาไทยพอใช้" },
  { id: "llama-1b", kind: "local", webllmId: "Llama-3.2-1B-Instruct-q4f16_1-MLC", name: "Llama 3.2 1B", provider: "Meta · ในเครื่อง", color: "#0866ff", rate: 1, downloadMB: 700, vramMB: 879, tags: ["อังกฤษ"], desc: "เก่งภาษาอังกฤษ ตอบไว" },
  { id: "qwen-1.5b", kind: "local", webllmId: "Qwen2.5-1.5B-Instruct-q4f16_1-MLC", name: "Qwen 2.5 1.5B", provider: "Alibaba · ในเครื่อง", color: "#6d4aff", rate: 2, downloadMB: 1000, vramMB: 1630, tags: ["ฉลาดขึ้น", "หลายภาษา"], desc: "ตอบละเอียดกว่า รองรับหลายภาษา" },
  { id: "gemma-2b", kind: "local", webllmId: "gemma-2-2b-it-q4f16_1-MLC", name: "Gemma 2 2B", provider: "Google · ในเครื่อง", color: "#1a73e8", rate: 2, downloadMB: 1450, vramMB: 1895, tags: ["เขียนเก่ง"], desc: "เขียนเนื้อหาลื่นไหล เหมาะงานเขียน" },

  { id: "gpt", kind: "cloud", status: "soon", name: "GPT-5", provider: "OpenAI", color: "#10a37f", rate: 12, tags: ["รอบด้าน", "เขียนโค้ด"], desc: "โมเดลเรือธงสำหรับงานทุกประเภท" },
  { id: "claude", kind: "cloud", status: "soon", name: "Claude Sonnet", provider: "Anthropic", color: "#d97757", rate: 12, tags: ["เขียนยาว", "วิเคราะห์"], desc: "เขียนเป็นธรรมชาติ วิเคราะห์เอกสารยาวได้ดี" },
  { id: "gemini", kind: "cloud", status: "soon", name: "Gemini Pro", provider: "Google", color: "#4285f4", rate: 10, tags: ["บริบทยาว", "มัลติโมดัล"], desc: "อ่านไฟล์และบริบทยาวมาก" },
  { id: "grok", kind: "cloud", status: "soon", name: "Grok", provider: "xAI", color: "#111111", rate: 10, tags: ["ข่าวล่าสุด"], desc: "ตอบตรงไปตรงมา ทันเหตุการณ์" },
  { id: "deepseek", kind: "cloud", status: "soon", name: "DeepSeek V3", provider: "DeepSeek", color: "#4d6bfe", rate: 4, tags: ["คณิต", "คุ้มค่า"], desc: "คิดเป็นขั้นตอน ราคาคุ้มค่า" },
  { id: "qwen-max", kind: "cloud", status: "soon", name: "Qwen Max", provider: "Alibaba", color: "#615ced", rate: 6, tags: ["หลายภาษา"], desc: "รุ่นใหญ่ของตระกูล Qwen" },
  { id: "mistral", kind: "cloud", status: "soon", name: "Mistral Large", provider: "Mistral AI", color: "#fa520f", rate: 6, tags: ["ยุโรป"], desc: "เร็วและแม่นยำ" },
  { id: "llama4", kind: "cloud", status: "soon", name: "Llama 4", provider: "Meta", color: "#0866ff", rate: 5, tags: ["โอเพนซอร์ส"], desc: "โมเดลเปิดรุ่นใหญ่" },
  { id: "sonar", kind: "cloud", status: "soon", name: "Perplexity Sonar", provider: "Perplexity", color: "#20808d", rate: 8, tags: ["ค้นเว็บ", "อ้างอิง"], desc: "ค้นข้อมูลจากเว็บพร้อมแหล่งอ้างอิง" },
  { id: "kimi", kind: "cloud", status: "soon", name: "Kimi K2", provider: "Moonshot", color: "#1f1f1f", rate: 5, tags: ["เอเจนต์"], desc: "ถนัดงานหลายขั้นตอน" },
];

export const IMAGE_MODELS = [
  { id: "nano-banana", name: "Nano Banana", provider: "Google", color: "#f9ab00", tags: ["แก้ภาพ", "สมจริง"] },
  { id: "gpt-image", name: "GPT Image", provider: "OpenAI", color: "#10a37f", tags: ["ตัวอักษรในภาพ"] },
  { id: "flux", name: "FLUX", provider: "Black Forest Labs", color: "#222", tags: ["ศิลปะ", "รายละเอียดสูง"] },
  { id: "seedream", name: "Seedream", provider: "ByteDance", color: "#3c8cff", tags: ["โปสเตอร์"] },
  { id: "ideogram", name: "Ideogram", provider: "Ideogram", color: "#e6007a", tags: ["โลโก้", "ตัวอักษร"] },
];

export const VIDEO_MODELS = [
  { id: "veo", name: "Veo", provider: "Google", color: "#4285f4", tags: ["มีเสียง", "1080p"] },
  { id: "kling", name: "Kling", provider: "Kuaishou", color: "#00c2a8", tags: ["เคลื่อนไหวสมจริง"] },
  { id: "sora", name: "Sora", provider: "OpenAI", color: "#10a37f", tags: ["เล่าเรื่อง"] },
  { id: "seedance", name: "Seedance", provider: "ByteDance", color: "#3c8cff", tags: ["เต้น", "ท่าทาง"] },
  { id: "runway", name: "Runway", provider: "Runway", color: "#111", tags: ["ตัดต่อ"] },
];

export const DEFAULT_MODEL_ID = "qwen-0.5b";

/** รวมค่าที่ super_user ตั้งไว้ (settings/models) ทับค่าเริ่มต้น */
export function mergeModels(overrides) {
  const o = overrides || {};
  return CHAT_MODELS.map((m) => ({ ...m, ...(o[m.id] || {}), id: m.id, kind: m.kind, webllmId: m.webllmId })).filter((m) => m.hidden !== true);
}

export const modelById = (list, id) => (list || CHAT_MODELS).find((m) => m.id === id) || (list || CHAT_MODELS)[0];
export const isUsable = (m) => !!m && m.kind === "local" && m.status !== "off";
export const fmtMB = (mb) => (mb >= 1000 ? (mb / 1000).toFixed(1) + " GB" : Math.round(mb) + " MB");

const KEY = "mixai:llm";
const read = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "{}");
    return v && typeof v === "object" ? v : {};
  } catch (e) {
    return {};
  }
};
const write = (v) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(v));
  } catch (e) {
    /* ข้าม */
  }
};
export const getSelectedModel = () => read().modelId || DEFAULT_MODEL_ID;
export const setSelectedModel = (id) => write({ ...read(), modelId: id });
